import { startOfDay, differenceInDays } from 'date-fns';
import { TZDate } from '@date-fns/tz';

import { Pipe, PipeTransform } from '@angular/core';

import { ApDateService } from '@ap/date';

/**
 * A Pipe that can be used to format dates relatively.
 **/
@Pipe({ name: 'relativeDate' })
export class RelativeDatePipe implements PipeTransform {
    public transform(value: any): string {
        return RelativeDatePipe.formatRelative(value);
    }

    private static formatRelative(dateToFormat: any): string {
        const date = startOfDay(dateToFormat);
        const today = new TZDate(startOfDay(new Date()), ApDateService.timezone);
        const diff = differenceInDays(date, today);

        switch (diff) {
            case 0:
                return 'Vandaag';
            case -1:
                return 'Gisteren';
            default:
                return ApDateService.formatRecent(date);
        }
    }
}
